import React, { useEffect } from 'react'
import { useSnackbar } from 'notistack';
import websocket from '../utils/WebsocketConnection';
import storageManager from '../utils/LocalStorageManager'

export default function DiceWebsocket({ connected, diceRolled }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    connect(connected)
    console.log('teste')
  }, [connected])

  const connect = (con) => {
    console.log(storageManager.getRoom())
    if (con)
      websocket.subscribeChannel(storageManager.getRoom(), 'dice', (data) => diceCallback(data))
    else
      websocket.disconnect();
  }

  const diceCallback = (data) => {
    enqueueSnackbar(data.playerName + " - " + data.text)
    if(diceRolled != null)
      diceRolled(data)
  }

  return (
    <>
    </>
  )
}
